//ACTION TYPE
const DRAWER_POSITION = "DRAWER_POSITION";
const LOGIN = "LOGIN";
const THEME = "THEME";
const EDIT_EVENTS = 'EDIT_EVENTS'
const EDIT_EVENTS_OLD_STATE = 'EDIT_EVENTS_OLD_STATE'

//ACTION CREATORS
export const drawerPosistion = (drawerOpen) => {
    return {
      type: DRAWER_POSITION,
      payload: {
        drawerOpen
      }
    };
  };

  export const login = (login) => {
    return {
      type: LOGIN,
      payload: {
        login
      }
    };
  };

  export const currentTheme = (theme) => {
    return {
      type: THEME,
      payload: {
        theme
      }
    };
  };

  export const editEvents = (editEvents, oldState) => {
    return {
      type: EDIT_EVENTS,
      payload: {
        editEvents,
        oldState
      }
    };
  };

  export const setOldState = (setOldState) => {
    console.log('action', setOldState)
    return {
      type: EDIT_EVENTS_OLD_STATE,
      payload: {
        setOldState
      }
    };
  };